<template>
  <div class="cta-block">
    <div class="block-wrapper">
      <div class="block-content">
        <strong>PROJECT</strong>
        <h2>{{ project.name }}</h2>
        <p>{{ project.description }}</p>
      </div>

      <div class="block-foot">
        <router-link class="button light" v-bind:to="'/project/' + project.id">
          {{ $t("group.projectBlock.button.open") }}
        </router-link>
        <router-link
          v-if="role !== 'Member'"
          class="history"
          v-bind:to="'/project/' + project.id + '/history'"
        >
          {{ $t("group.projectBlock.link.history") }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["project", "role"],
  name: "ProjectBlock",
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cta-block {
  margin-bottom: 20px;
  flex: 0 1 24%;

  .block-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: $surface-alpha;
    border: 1px solid $border-alpha;
    padding: 12px;
    margin-right: 20px;
  }
}

a {
  color: $text-accent-alpha;
  text-decoration: underline;
}

h2 {
  color: $primary;
  font-weight: $semi-bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

h3 {
  color: $primary;
}

.history {
  margin-top: 17px;
  line-height: 30px;
  float: right;
}

.block-content {
  flex: 1 0 auto;
}

.block-foot {
  flex: 0 1 auto;
}
</style>
